export class ReferralInfoModel {

    clientId: number;
    clientType: string;
    clientSubtype: string;
    date: number;
    name: string;
    refId: string;

    constructor(obj?: any) {
        this.clientId       = obj && obj.clientId       || '';
        this.clientType     = obj && obj.clientType     || '';
        this.clientSubtype  = obj && obj.clientSubtype  || '';
        this.date           = obj && obj.date           || '';
        this.name           = obj && obj.name           || '';
        this.refId          = obj && obj.refId          || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/referral-info.model.ts